<template>
    <div class="my">
        <div class="header_img">
            <img src="https://img1.outnice.cn/images/2020/09/08/image_1599578981_NkWxff9a.png" width="100%"/>
        </div>
        <div class="my_header">
            <van-skeleton title avatar :row="2" v-if="userInfo==''"/>
            <template v-else>
                <div class="head-content">
                    <img :src="userInfo.head_portrait" alt="" class="avatar">
                    <div class="content">
                        <div class="oneline line1">{{userInfo.nickname}}</div>
                        <div class="line2">{{userInfo.mobile}}</div>
                    </div>
                    <div @click="editUser" class="mvbutton edit">编辑信息</div>
                </div>
            </template>
        </div>
        <div class="user-body">
            <div class="user-item" v-for="(item,index) in links" :key="index" @click="go(item)">
                <div class="">
                    <img class="" :src="item.imgurl" mode="scaleToFill"></img>
                    <div>
                        <div>{{item.name}}</div>
                        <div>{{item.ename}}</div>
                    </div>
                </div>
                <div v-if="item.icon"><img class="" :src="item.icon" mode="scaleToFill"></img></div>
            </div>
        </div>
        <!-- <van-popup v-model="show" :close-on-click-overlay="false" closeable close-icon="close"  :style="{ height: 'auto','background-color':'transparent' }">
            <div class="signwrapper">
                <div class="block">
                    <div class="block_header">
                        <div>已连续登录<span>{{userInfo.continuity}}</span>天，连续签到10天可<br/>多领取5个健康值哦！</div>
                    </div>
                    <div class="block_body">
                        <div class="html">{{userInfo.signpoint}}</div>
                    </div>
                    <div class="footer">
                        <div class="mvbutton home" @click="receive">
                            领取健康值
                        </div>
                        <div class="notice">*每日只可领取一次</div>
                    </div>
                </div>
            </div>
        </van-popup> -->
    </div>
</template>
<script>
    import './index.less'
    import {Cell, CellGroup,Popup} from 'vant'

    export default {
        data() {
            return {
                userInfo: '',
                links: [ ],
                show:false
            }
        },
        components: {
            Cell,
            CellGroup,
            vanPopup:Popup
        },
        methods: {
            editUser(){
              this.$router.push({name:"userEdit"})
            },
            goexchange() {
                this.$router.push({name:'showrank',params: {id: 1}})
            },
            goindex() {
                this.$router.push({name: "exchange"});

            },
            getUserInfo() {
                this.$api.system.info().then((res) => {
                    if (res.code * 1 === 200) {
                        this.userInfo = res.data
                        this.links = res.data.fun
                    }
                })
            },
            go(val) {
                if(val.path=='feedback'){
                    window.localStorage.clear();
                    window.location.reload();
                    // this.$router.push({name: "login"});
                }else  this.$router.push(val.path);
            }
        },
        mounted() {
            this.getUserInfo()
        }
    }
</script>
